export default __webpack_public_path__ + "static/media/01.ba05ca6e.png";